<div class="call-main">
  <div class="pop-up-heading">
     <br>Request a Callback
  </div>
  <div class="pop-up-info">
    Please fill the details below and we will get in touch with you
  </div>
  <form name="form" (ngSubmit)="f.form.valid && processForm()" #f="ngForm" novalidate>
  <div class="col-lg-12 row">

      <div class="col-lg-6">
          <label  class="lbl-text">First Name <span class="mandatory"> *</span></label><br>
          <input type="text" [pattern]="alphaPattern" minlength="1" maxlength="32"  [(ngModel)]="firstName" autocomplete="off" name="first" #fname="ngModel" required>
          <div *ngIf="f.submitted && fname.invalid" class="error-text">
            <div *ngIf="fname.errors.required">First name is required</div>
            <div *ngIf="fname.errors.pattern">Name not valid.</div>
          </div>
      </div>
      <div class="col-lg-6">
          <label  class="lbl-text">Last Name <span class="mandatory"> *</span></label><br>
          <input type="text"  [pattern]="alphaPattern" minlength="1" maxlength="32"  [(ngModel)]="lastName" autocomplete="off" name="last"   #lname="ngModel" required>
          <div *ngIf="f.submitted && lname.invalid" class="error-text">
            <div *ngIf="lname.errors.required">Last name is required</div>
            <div *ngIf="lname.errors.pattern">Name not valid.</div>
          </div>
      </div>
      <div class="col-lg-6">
          <label  class="lbl-text">Mobile <span class="mandatory"> *</span></label><br>
          <input type="text" [pattern]="mobNumberPattern" [(ngModel)]="userData.mobileNumber" autocomplete="off" name="mobile"   #mobile="ngModel" required
          minlength="10" maxlength="10">
          <div class="error-text">
            <div *ngIf="f.submitted && mobile.errors?.required">Mobile number required</div>
            <div *ngIf="mobile.errors?.pattern">Mobile number not valid.</div>
        </div>
      </div>
      <div class="col-lg-6">
          <label  class="lbl-text">Email ID<span class="mandatory"> *</span></label><br>
          <input type="text"  minlength="5" maxlength="64"  [(ngModel)]="userData.emailId" autocomplete="off" name="email"  #email="ngModel" required email>
          <div *ngIf="f.submitted && email.invalid" class="error-text">
            <div *ngIf="email.errors.required">Email required</div>
            <div *ngIf="email.errors.email">Enter a valid email address</div>
          </div>
      </div>
      <div class="col-lg-6">
        <label  class="lbl-text">City <span class="mandatory"> *</span></label><br>
        <input type="text" [pattern]="alphaPattern" minlength="1" maxlength="32"  [(ngModel)]="userData.city" autocomplete="off" name="city"  #cityname="ngModel" required>
        <div *ngIf="f.submitted && cityname.invalid" class="error-text">
          <div *ngIf="cityname.errors.required">City required</div>
          <div *ngIf="cityname.errors.pattern">City not valid.</div>
        </div>
    </div>

      <div class="col-lg-12">
          <label  class="lbl-text">Message </label><br>
          <textarea rows="1" [pattern]="msgPattern" maxlength="100" placeholder="Message (Maximum 100 characters)" name="message" #message="ngModel"  [(ngModel)]="userData.message" autocomplete="off"></textarea>
          <div *ngIf="f.submitted && message.invalid" class="error-text">
            <div *ngIf="message.errors.pattern">Invalid message.</div>
          </div>
        </div>
      <div class="col-lg-12 text-center">
          <button class="submit-button btn-spc ">Submit</button>
      </div>
  </div>
</form>
<button type="button" class="floating-button content-mobile-section" (click)="investOnline()" >Invest Online</button>

</div>
